<template>
    <defaultSec :title="'在职继承'">
        <keep-alive>
            <el-form class="demo-form-inline select-wrap config-form" size="mini">
                <el-form-item label="继承类型">
                    <el-radio-group v-model="transferMode" :disabled="savingConfig">
                        <el-radio-button label="active">在职继承</el-radio-button>
                        <el-radio-button label="resigned">离职继承</el-radio-button>
                    </el-radio-group>
                    <span class="mode-tip">{{ transferMode === 'resigned' ? '按离职继承接口转移客户' : '按在职继承接口转移客户' }}</span>
                </el-form-item>
                <el-form-item label="转移话术" class="msg-item">
                    <el-input
                        type="textarea"
                        :rows="3"
                        v-model="transferSuccessMsg"
                        :disabled="savingConfig"
                        maxlength="1000"
                        show-word-limit
                        placeholder="请输入转移话术，将随转移操作发送给客户">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="savingConfig" @click="saveConfig()">保存配置</el-button>
                    <el-button type="success" @click="transfer()">转移</el-button>
                </el-form-item>
                <div class="config-tip">
                    提示：配置需先「保存配置」后生效；转移由定时任务按批次执行，点「转移」仅整理名单并生成批次。
                </div>
            </el-form>
        </keep-alive>
        <el-table :data="dataList" border size="mini" v-loading="loading" element-loading-text="统计中，请稍后...">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="企微号" prop="qwId" width="180"></el-table-column>
            <el-table-column label="企微" prop="qwName" width="190"></el-table-column>
            <el-table-column label="用户数" prop="addCount" width="150"></el-table-column>
            <el-table-column label="可转移数量" prop="canTransferCount" width="230"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-radio-group size="mini" v-model="scope.row.radio">
                        <el-radio-button :label="0">不操作</el-radio-button>
                        <el-radio-button :label="1" :disabled="scope.row.canTransferCount <= 0">转出</el-radio-button>
                        <el-radio-button :label="2">转入</el-radio-button>
                    </el-radio-group>
                </template>
            </el-table-column>
            <el-table-column label="数量">
                <template slot-scope="scope">
                    <el-input-number size="mini" v-model="scope.row.transferCount" @change="handleChange" :min="0" :max="scope.row.radio==1?scope.row.canTransferCount:999999" label="数量"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="danger" plain size="mini" @click="quit(scope.row.qwId)">改为离职</el-button>
                </template>
            </el-table-column>
        </el-table>
    </defaultSec>
</template>

<script>
import defaultSec from '@c/defaultSection'

// 配置读写的批次号：这里只存一份「当前生效配置」，
// 页面保存后由后端在新批次发起转移时读取，历史批次各自保留自己的模式与话术。
const CONFIG_BATCH_NO = 'default'

// 转移话术默认值（可修改）。与后端兜底话术保持一致，
// 首次进入页面或配置为空时用它回填，避免用户面对空输入框。
const DEFAULT_TRANSFER_MSG = 'Hi小伙伴，来和你说一下我升级了账号功能，马上会自动更新哈，等下为你准备了「乐享杯」兑换券作为礼物 :)'

export default {
    data() {
        return {
            dataList: [],
            showDialog: false,
            loading: true,
            transferMode: 'active',
            transferSuccessMsg: DEFAULT_TRANSFER_MSG,
            savingConfig: false
        }
    },
    components: {
        defaultSec
    },
    mounted(){
        this.initConfig()
        this.initList()
    },
    methods: {
        // 回填已保存的配置；无配置或读取失败时保留默认值，不阻断页面
        initConfig() {
            this.$apiGet('lechun-cms/qiyeweixin/getTransferConfig', {batchNo: CONFIG_BATCH_NO}).then(res => {
                if (res) {
                    if (res.transferMode) {
                        this.transferMode = res.transferMode
                    }
                    if (res.successMsg) {
                        this.transferSuccessMsg = res.successMsg
                    }
                }
            }).catch(() => {
                // 首次尚无配置，保持默认值即可
            })
        },
        saveConfig(silent) {
            if (!this.transferSuccessMsg || !this.transferSuccessMsg.trim()) {
                this.$message({type: 'error', message: '转移话术不能为空'})
                return Promise.resolve(false)
            }
            this.savingConfig = true
            return this.$apiGet('lechun-cms/qiyeweixin/saveTransferConfig', {
                batchNo: CONFIG_BATCH_NO,
                transferMode: this.transferMode,
                successMsg: this.transferSuccessMsg
            }).then(() => {
                this.savingConfig = false
                if (!silent) {
                    this.$message({type: 'success', message: '配置保存成功'})
                }
                return true
            }).catch(() => {
                this.savingConfig = false
                return false
            })
        },
        initList() {
            this.dataList = [];
            this.$apiGet('lechun-cms/qiyeweixin/qwListForTransfer', this.formParam).then(res => {
                this.loading = false
                this.dataList = res.map((item)=>{
                    item.radio = 0
                    item.transferCount = 0
                    return item
                })
            });
        },
        transfer(){
            // 校验转入转出数量是否相等
            let handOverIds = "";
            let takeOverIds = "";
            let handOverCount = 0;
            let takeOverCount = 0;
            this.dataList.forEach((data) => {
                if(data.radio == 1 && data.transferCount > 0){
                    handOverIds = handOverIds + data.qwId + "--" + data.transferCount + "__";
                    handOverCount = handOverCount + data.transferCount;
                } else if(data.radio == 2 && data.transferCount > 0){
                    takeOverIds = takeOverIds + data.qwId + "--" + data.transferCount + "__";
                    takeOverCount = takeOverCount + data.transferCount;
                }
            })
            if(handOverCount <= 0 || takeOverCount <= 0 || handOverCount != takeOverCount){
                this.$message({
                    type: 'error',
                    message: '转入转出数量必须相等且大于0'
                });
                return
            }
            if(!this.transferSuccessMsg || !this.transferSuccessMsg.trim()){
                this.$message({type: 'error', message: '转移话术不能为空'})
                return
            }
            const modeName = this.transferMode === 'resigned' ? '离职继承' : '在职继承'
            this.$confirm(`确定按【${modeName}】发起转移吗？转移人数 ${handOverCount} 人。`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 先把「继承模式 + 话术」保存为当前生效配置，再发起转移，
                // 保证后端定时任务取到的是页面上这份配置。
                this.saveConfig(true).then((ok) => {
                    if (!ok) {
                        return
                    }
                    this.$apiGet('lechun-cms/qiyeweixin/manualTransferCustomer', {
                        'handOverIds': handOverIds,
                        'takeOverIds': takeOverIds,
                        'transferMode': this.transferMode,
                        'transferSuccessMsg': this.transferSuccessMsg
                    }).then(() => {
                        this.showDialog = false;
                        this.$message({type: 'success', message: '已发起转移'})
                        this.initList()
                    });
                })
            }).catch(() => {})
        },
        quit(){
            this.$confirm('确定已经在企微后台操作为离职了吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.initList();
            }).catch(() => {

            });
        }
    }
}
</script>

<style scoped>
.expand-title {
    width: 70px;
    color: #444548;
    line-height: 30px;
    text-align: right;
    margin-right: 10px;
    font-weight: 600;
}

.expand-flex {
    justify-content: flex-start;
    align-items: center;
    align-content: center;
}

.config-form >>> .el-form-item {
    display: block;
    margin-bottom: 12px;
}

.config-form >>> .el-form-item__label {
    float: none;
    display: inline-block;
    vertical-align: top;
    line-height: 28px;
}

.msg-item {
    width: 100%;
    max-width: 860px;
}

.msg-item >>> .el-form-item__content {
    width: 100%;
    max-width: 780px;
}

.msg-item >>> .el-textarea {
    vertical-align: top;
}

.mode-tip {
    color: #909399;
    font-size: 12px;
    margin-left: 10px;
}

.config-tip {
    display: block;
    color: #909399;
    font-size: 12px;
    line-height: 18px;
    margin: 0 0 10px 0;
}
</style>